import { render, staticRenderFns } from "./ContactoModalNuevo.vue?vue&type=template&id=1d5d73a1&scoped=true&"
import script from "./ContactoModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ContactoModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ContactoModalNuevo.vue?vue&type=style&index=0&id=1d5d73a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d73a1",
  null
  
)

export default component.exports